<template lang="pug">
.pricebuilder-wrapper
  .button-flex
    .button-wrapper  
      b-button(type="is-light" icon-left="plus" @click="newRentObjectPrice()") Neuen Preis anlegen
      b-button(type="is-light" icon-left="plus" @click="copyYearPrice()") Jahrespreis kopieren
      .spacer.md.inline
    CopyPasteModal(:id="id" :rentObjectType="rentObjectType" destination="Preise" @copySuccess="reloadData()")
  
  .margin-top
    .card
      .main
        b-table(
        :data="rentObjectPrices",
        default-sort-direction="asc",
        default-sort="startDate",
        :selected="tableSelected"
        hoverable)
          b-table-column(field="name", label="Name", sortable, v-slot="props")
            | {{ props.row.name }}
          b-table-column(
            field="startDate",
            label="Ab dem",
            sortable,
            v-slot="props")
            | {{ formatISODate(props.row.startDate) }}
          b-table-column(
            field="startDate",
            label="Bis zum",
            sortable,
            v-slot="props")
            | {{ rentObjectPrices[props.index + 1] ? formatISODate(rentObjectPrices[props.index + 1].startDate) : '∞' }}
          b-table-column(
            field="price",
            label="Preis",
            sortable,
            v-slot="props")
            | {{ props.row.price/100 | toCurrency }}
          b-table-column(
            field="inclusivePersons",
            label="Pers. inkl.",
            sortable,
            v-slot="props")
            | {{ props.row.inclusivePersons }}
          b-table-column(
            field="pricePerExtraPerson",
            label="Preis p. Zusatzperson",
            sortable,
            v-slot="props")
            | {{ props.row.pricePerExtraPerson/100 | toCurrency }}
          b-table-column(
            field="minNights",
            label="mind. ÜN",
            sortable,
            v-slot="props")
            | {{ props.row.minNights }}
          b-table-column(v-slot="props")
            div
              b-tooltip(label='Bearbeiten' type='is-secondary' position='is-bottom' :delay="1250")
                b-button(icon-right="pencil", type="is-secondary" @click="tableSelected = rentObjectPrices[props.index]; openModal(props.row)")
              .spacer.sm.inline
              b-tooltip(label='Dauerhaft löschen' type='is-danger' position='is-bottom' :delay="1250")
                b-button(icon-right="close", type="is-danger" @click="deletePrice(props.row)")

    //- b-modal(v-model='isModalActive' has-modal-card='' trap-focus='' :destroy-on-hide='true' aria-role='dialog' aria-modal='')
    //-   template(#default='props')
    .modal-fixed(v-if="isCopyYearPriceModal")
      .form.w400.max
        .card.margin-top
          .top
            h2.title.is-6 Preis aus einem Jahr in ein neues Jahr kopieren
            ValidationObserver(v-slot="{ handleSubmit }", ref="form")
              ValidationProvider(
              name="Basisjahr",
              rules="required",
              v-slot="{ errors, valid }")
                b-field(
                  label="Basisjahr",
                  label-position="on-border",
                  :type="{ 'is-danger': errors[0]}",
                  :message="errors"
                )
                  b-select(v-model="copyPrice.baseYear")
                    option(v-for="i in 12" :value="new Date().getFullYear() + i - 3") {{ new Date().getFullYear() + i - 3}}
              ValidationProvider(
              name="Zieljahr",
              rules="required",
              v-slot="{ errors, valid }")
                b-field(
                  label="Zieljahr",
                  label-position="on-border",
                  :type="{ 'is-danger': errors[0]}",
                  :message="errors"
                )
                  b-select(v-model="copyPrice.targetYear")
                    option(v-for="i in 9" :value="new Date().getFullYear() + i") {{ new Date().getFullYear() + i }}
              .spacer.sm
              b-message(v-if="copyPrice.baseYear && copyPrice.targetYear" title="Zusammenfassung" type="is-warning" :closable="false")
                | Wenn Sie auf den Button "Jetzt kopieren" drücken, werden fehlende Jahrespreise in das Jahr {{copyPrice.targetYear}} aus dem Jahr {{copyPrice.baseYear}} kopiert.
              .button-wrapper.margin-top.right
                b-button(
                  type="is-light",
                  @click="isCopyYearPriceModal = false"
                ) Abbrechen
                b-button(
                  type="is-primary",
                  @click="handleSubmit(copyPrices)"
                ) Jetzt kopieren
    
    .modal-fixed(v-if="isModalActive")
      .form.w400.max
        .card.margin-top
          .top
            h2.title.is-6(v-if="formData.id") Preis aktualisieren
            h2.title.is-6(v-else) Neuer Preis {{formData.startDate ? `für den ${formatJSDate(formData.startDate)}` : ''}}
            ValidationObserver(v-slot="{ handleSubmit }", ref="form")
              ValidationProvider(
              name="Name",
              rules="required",
              v-slot="{ errors, valid }")
                b-field(
                  label="Name",
                  label-position="on-border",
                  :type="{ 'is-danger': errors[0]}",
                  :message="errors"
                )
                  b-input(v-model="formData.name")
              ValidationProvider(
                name="Ab dem",
                rules="required",
                v-slot="{ errors, valid }")
                b-field(
                  label="Ab dem",
                  label-position="on-border",
                  :type="{ 'is-danger': errors[0]}",
                  :message="errors"
                )
                  v-date-picker(is-expanded v-model="formData.startDate" ref="datepicker")
              ValidationProvider(
                name="Preis (€)",
                :rules="{ required: true, currency: /^[+-]?[0-9]{1,3}(?:,?[0-9]{3})*\.[0-9]{2}$/ }",
                v-slot="{ errors, valid }")
                b-field(
                  label="Preis (€)",
                  label-position="on-border",
                  :type="{ 'is-danger': errors[0]}",
                  :message="errors")
                  b-input(v-model="formData.price")
              ValidationProvider(
                v-if="rentObjectType.uuid !== 'PARKING'"
                name="Personen inkl.",
                rules="required",
                v-slot="{ errors, valid }")
                b-field(
                  label="Personen inkl.",
                  label-position="on-border",
                  :type="{ 'is-danger': errors[0]}",
                  :message="errors")
                  b-select(v-model="formData.inclusivePersons" expanded)
                    option(v-for="p, idx in maxPersons" :value="idx+1") {{idx+1}} Person
              ValidationProvider(
                v-if="rentObjectType.uuid !== 'PARKING'"
                name="Preis pro Zusatzperson (€)",
                :rules="{ required: false, currency: /^[+-]?[0-9]{1,3}(?:,?[0-9]{3})*\.[0-9]{2}$/ }",
                v-slot="{ errors, valid }")
                b-field(
                  label="Preis pro Zusatzperson (€)",
                  label-position="on-border",
                  :type="{ 'is-danger': errors[0]}",
                  :message="errors")
                  b-input(v-model="formData.pricePerExtraPerson")
              ValidationProvider(
                name="mind. ÜN",
                rules="required",
                v-slot="{ errors, valid }"
              )
                b-field(
                  label="mind. ÜN",
                  label-position="on-border",
                  expanded,
                  :type="{ 'is-danger': errors[0]}",
                  :message="errors")
                  b-select(v-model="formData.minNights" expanded)
                    option(value="1") 1 Übernachtung
                    option(value="2") 2 Übernachtungen
                    option(value="3") 3 Übernachtungen
                    option(value="4") 4 Übernachtungen
                    option(value="5") 5 Übernachtungen
                    option(value="6") 6 Übernachtungen
                    option(value="7") 7 Übernachtungen
                    option(value="8") 8 Übernachtungen
                    option(value="9") 9 Übernachtungen
                    option(value="10") 10 Übernachtungen

              .button-wrapper.margin-top.right
                b-button(
                  type="is-light",
                  @click="isModalActive = false"
                ) Abbrechen
                b-button(
                  v-if="formData.id"
                  type="is-primary",
                  @click="handleSubmit(updatePrice)"
                ) Aktualisieren
                b-button(
                  v-else
                  type="is-primary",
                  @click="handleSubmit(savePrice)"
                ) Speichern
  .spacer.md
  .button-flex
    .button-wrapper  
      b-button(type="is-light" icon-left="plus" @click="newRentObjectPrice()") Neuen Preis anlegen
      b-button(type="is-light" icon-left="plus" @click="copyYearPrice()") Jahrespreis kopieren
      .spacer.md.inline
    CopyPasteModal(:id="id" :rentObjectType="rentObjectType" destination="Preise" @copySuccess="reloadData()")
</template>

<script>
import {DateTime} from "luxon";
import CopyPasteModal from "@/components/molecules/CopyPasteModal.vue";

export default {
  components: {
    CopyPasteModal
  },
  props: {
    id: {
      type: [Number, String],
      default: null,
    },
    rentObjectType: {
      type: Object,
      default: null
    },
    maxPersons: {
      type: Number,
      default: 1
    },
  },
  data() {
    return {
      isModalActive: false,
      isCopyYearPriceModal: false,
      rentObjectPrices: [],
      tableSelected: null,
      formData: {
        name: null,
        startDate: null,
        price: null,
        inclusivePersons: null,
        pricePerExtraPerson: null,
        minNights: null,
      },
      copyPrice: {
        baseYear: null,
        targetYear: null,
      }
    };
  },
  computed: {
    allDatesUnique() {
      let unique = true;
      for (let x = 0; x < this.rentObjectPrices.length; x += 1) {
        let startDate = DateTime.fromISO(this.rentObjectPrices[x].startDate);
        if (!startDate.toISODate()) {
          startDate = DateTime.fromJSDate(this.rentObjectPrices[x].startDate);
        }
        // Check if selected date is dublicate as well
        const newStartDate = DateTime.fromJSDate(this.formData.startDate)
        if (newStartDate.toISODate() === startDate.toISODate()) {
          unique = false;
          break;
        }
        for (let y = 0; y < this.rentObjectPrices.length; y += 1) {
          let startDate2 = DateTime.fromISO(this.rentObjectPrices[y].startDate);
          if (!startDate2.toISODate()) {
            startDate2 = DateTime.fromJSDate(this.rentObjectPrices[y].startDate);
          }
          if (x !== y && startDate.toISODate() === startDate2.toISODate()) {
            unique = false;
            break;
          }
        }
        if (!unique) {
          break;
        }
      }
      return unique;
    }
  },
  methods: {
    newRentObjectPrice() {
      this.formData = {
        name: null,
        startDate: null,
        price: null,
        persons: null,
        pricePerExtraPerson: null,
        minNights: null,
      };
      this.formData.startDate = this.rentObjectPrices.length > 0 ? new Date(this.rentObjectPrices[this.rentObjectPrices.length - 1].startDate) : new Date();
      this.isModalActive = true;
    },
    openModal(p) {
      this.formData = {...this.formData, ...p, price: (p.price/100).toFixed(2), pricePerExtraPerson: (p.pricePerExtraPerson/100).toFixed(2)};
      this.formData.startDate = DateTime.fromISO(this.formData.startDate).toJSDate();
      this.isModalActive = true;
      const datepicker = this.$refs.datepicker;
      datepicker.move(this.formData.startDate);
    },
    copyYearPrice() {
      this.isCopyYearPriceModal = true;
    },
    formatISODate(d) {
      const dt = DateTime.fromISO(d);
      return dt.setLocale('de')
        .toFormat('dd. LLL yy')
    },
    formatJSDate(d) {
      const dt = DateTime.fromJSDate(d);
      return dt.setLocale('de')
        .toFormat('dd.LL.yyyy')
    },
    parsePricesToLocalVariable() {
      this.rentObjectPrices = JSON.parse(
        JSON.stringify(this.$store.state.rentObjectPrices.all)
      );

      // Hide dates in the past
      this.rentObjectPrices = this.rentObjectPrices.filter((r, idx) => this.rentObjectPrices[idx+1] ? new Date(this.rentObjectPrices[idx+1].startDate) > new Date() : true);
    },
    async savePrice() {
      const centPrice = parseInt(this.formData.price.replace(",", ".") * 100);
      let centPricePerExtraPerson = 0;
      if (this.formData.pricePerExtraPerson) {
        centPricePerExtraPerson = parseInt(this.formData.pricePerExtraPerson.replace(",", ".") * 100);
      }
      await this.$store.dispatch("rentObjectPrices/create", {
        rentObjectId: this.id,
        ...this.formData,
        startDate: DateTime.fromJSDate(this.formData.startDate).toISODate(),
        price: centPrice,
        pricePerExtraPerson: centPricePerExtraPerson,
      });
      await this.$store.dispatch("rentObjectPrices/findAll", {
        id: this.id,
      });

      this.parsePricesToLocalVariable();
      this.isModalActive = false;
    },
    async copyPrices() {
      const allBasePrices = this.rentObjectPrices.filter(r => new Date(r.startDate).getFullYear() === this.copyPrice.baseYear);
      const allTargetPrices = this.rentObjectPrices.filter(r => new Date(r.startDate).getFullYear() === this.copyPrice.targetYear);
      if (allBasePrices.length === 0) {
        this.$buefy.toast.open(`Es wurden keine Preise für das Jahr ${this.copyPrice.baseYear} gefunden. Somit können auch keine Preise in das Jahr ${this.copyPrice.targetYear} kopiert werden.`);
      }
      let copyCount = 0;
      for (let i = 0; i < allBasePrices.length; i += 1) {
        
        // Check if dublicates
        let isUnique = true;
        for (let a = 0; a < allTargetPrices.length; a += 1) {
          if (allBasePrices[i].startDate.substring(5, 10) === allTargetPrices[a].startDate.substring(5, 10)) {
            isUnique = false;
            break;
          }
        }
        if (isUnique) {
          copyCount += 1;
          await this.$store.dispatch("rentObjectPrices/create", {
            ...allBasePrices[i],
            startDate: allBasePrices[i].startDate.replace(this.copyPrice.baseYear, this.copyPrice.targetYear),
            id: undefined,
            createdAt: undefined,
            updatedAt: undefined,
          });
        }
      }
      this.$buefy.toast.open(`Erfolgreich ${copyCount} Preise in das Jahr ${this.copyPrice.targetYear} kopiert.`);
      await this.$store.dispatch("rentObjectPrices/findAll", {
        id: this.id,
      });
      this.parsePricesToLocalVariable();
      this.isCopyYearPriceModal = false;
    },
    async updatePrice() {
      const centPrice = parseInt(this.formData.price.replace(",", ".") * 100);
      let centPricePerExtraPerson = 0;
      if (this.formData.pricePerExtraPerson) {
        centPricePerExtraPerson = parseInt(this.formData.pricePerExtraPerson.replace(",", ".") * 100);
      }
      await this.$store.dispatch("rentObjectPrices/update", {
        ...this.formData,
        startDate: DateTime.fromJSDate(this.formData.startDate).toISODate(),
        price: centPrice,
        pricePerExtraPerson: centPricePerExtraPerson});
      await this.$store.dispatch("rentObjectPrices/findAll", {
        id: this.id,
      });
      this.parsePricesToLocalVariable();
      this.$refs.form.reset();
      this.isModalActive = false;
    },
    deletePrice(price) {
      this.$buefy.dialog.confirm({
        title: "Preis löschen",
        message: `Sind Sie sicher, dass Sie diesen Preis <b>${price.name}</b> löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.`,
        confirmText: "Jetzt löschen",
        cancelText: "Abbrechen",
        type: "is-danger",
        hasIcon: true,
        onConfirm: async () => {
          try {
            await this.$store.dispatch("rentObjectPrices/delete", {
              id: price.id,
            });
            await this.$store.dispatch("rentObjectPrices/findAll", {
              id: this.id,
            });
            this.parsePricesToLocalVariable();
          } catch (e) {
            this.$store.dispatch(
              "common/showError",
              "Preis konnte nicht gelöscht werden."
            );
          }
        },
      });
    },
    async reloadData() {
      await this.$store.dispatch("rentObjectPrices/findAll", {
        id: this.id
      });
      this.parsePricesToLocalVariable();
    }
  },
  async mounted() {
    await this.$store.dispatch("rentObjectPrices/findAll", {
      id: this.id,
    });

    this.parsePricesToLocalVariable();
  },
};
</script>

<style lang="scss">
.control.input-text-right {
  input {
    text-align: right;
  }
}
.modal-fixed {
  position: fixed;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}
</style>